import React from 'react';
import Moment from 'react-moment';
import { withRouter } from 'react-router';
import { Button } from 'components/ui/form';
import styles from '../../order.module.scss';

const Success = ({ order, onClose }) => (
  <>
    <div>
      <h2 className={styles.successTitle}>Благодарим вас за заказ!</h2>
      <p className={styles.successText}>
        Ваш заказ на поставку №
        {`${order.id} `}
        от
        {' '}
        <Moment>{order.date}</Moment>
        {' '}
        создан и зарегистрирован в электронной очереди.
      </p>
      <p className={styles.successText}>
        Вы можете следить за статусом вашей заявки в очереди.
      </p>
    </div>
    <div className={styles.successLinks}>
      <div>
        <Button onClick={onClose}>Мои заказы</Button>
      </div>
    </div>
  </>
);

export default withRouter(Success);
